.page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}

.card {
  width: min(420px, 100%);
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 28px 24px;
  background: var(--white);
  border: 2px solid var(--ink);
  border-radius: 20px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.name {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 20px;
}

.badge {
  padding: 3px 8px;
  background: var(--purple);
  border-radius: var(--r-pill);
  font-size: 11px;
  font-weight: 700;
}

.title {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 24px;
  line-height: 1.2;
}

.sub {
  margin: 0;
  color: var(--text-2);
  line-height: 1.45;
}

.status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  background: var(--lav);
  border-radius: var(--r-md);
  font-weight: 600;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
